// extracted by mini-css-extract-plugin
export default {"text":"EmailVerification_text__5sX0c"};